export default __webpack_public_path__ + "static/media/projectIcon.67a72eee.svg";